import { CheckoutItemDetails } from './checkout-item-details.interface';

export interface CheckoutItem {
  item: CheckoutItemDetails;
  itemIterationId: number;
}
